/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type STORY_STATUS = "CLOSED" | "OPEN" | "%future added value";
export type StoryStatusContainer_story = {
    readonly id: string;
    readonly status: STORY_STATUS;
    readonly isArchiving: boolean;
    readonly isArchived: boolean;
    readonly isUnarchiving: boolean;
    readonly " $refType": "StoryStatusContainer_story";
};
export type StoryStatusContainer_story$data = StoryStatusContainer_story;
export type StoryStatusContainer_story$key = {
    readonly " $data"?: StoryStatusContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"StoryStatusContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StoryStatusContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isArchiving",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isArchived",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isUnarchiving",
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '14a50fbc02b8f94f3363d57f90ef6e8c';
export default node;
